module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_kawaduzakura-ff1cdb827708ab64e75187ac5b695bb2.jpg";